import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import PropTypes from 'prop-types';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

const SettlementPdfViewer = ({ file }) => {
  const [nPages, setNPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNPages(numPages);
  };

  return (
    <div>
      {file && (
        <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.from(new Array(nPages), (_, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} />
          ))}
        </Document>
      )}
    </div>
  );
};

SettlementPdfViewer.propTypes = {
  file: PropTypes.string,
};

SettlementPdfViewer.defaultProps = {
  file: '',
};

export default SettlementPdfViewer;
